export default class SolaceWorkerInterface {

  constructor({host, vpn, onStreamingMessageReceived, onConnectionRecovered, onException}) {
    this.host = host;
    this.vpn = vpn;
    this.messageReceiver = new (require('./api-message-receiver.js'))(onStreamingMessageReceived);
    this.worker = new Worker('worker.js');
    this.connected = false;
    window.enableLogging = () => {
      this.worker.postMessage({
        method: 'enableLogging',
        args: []
      });
    };

    window.disableLogging = () => {
      this.worker.postMessage({
        method: 'disableLogging',
        args: []
      });
    };

    this.worker.onmessage = (e) => {
      switch (e.data.event) {
        case 'connected': {
          this.connected = true;
          this.onConnectionSuccess();
          break;
        }
        case 'reconnected': {
          onConnectionRecovered();
          break;
        }
        case 'apiMessageReceived': {
          this.messageReceiver.handle(e.data.message);
          break;
        }
        case 'loginFailed': {
          // provide non-success response type
          this.onConnectionFail({
            responseType: 1
          });
          break;
        }
        case 'solaceException': {
          onException();
        }
      }
    }
  }

  connect(userId, password, onConnectionSuccess, onConnectionFail) {
    this.onConnectionSuccess = onConnectionSuccess;
    this.onConnectionFail = onConnectionFail;
    this.worker.postMessage({
      method: 'connect',
      args: [this.host, this.vpn, userId, password]
    });
  }

  disconnect() {

  }

  send(request, requestPatternType, callback, clientReferenceId, requestTopic) {
    if (callback) {
      this.messageReceiver.registerCallback(request, requestPatternType, callback, clientReferenceId);
    } else {
      request["clientRefId"] = clientReferenceId;
    }

    this.worker.postMessage({
      method: 'send',
      args: [request, requestTopic]
    });
  }

  isConnected() {
    return this.connected;
  }
}


// WEBPACK FOOTER //
// ./src-client-lib/solace/solaceWorkerInterface.js